import React from 'react';

interface IAddIconProps {
  style?: any;
  onClick?: () => void;
}

export const AddIcon:React.FC<IAddIconProps> = (props: IAddIconProps) => {
  return (
    <svg onClick={props.onClick} xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 17 17" style={props.style}>
        <path fill={props.style?.fillColor ? props.style.fillColor : "#fff"} d="M16.121 9.334H9.333v6.788H7.636V9.334H.848V7.637h6.788V.849h1.697v6.788h6.788v1.697z"/>
    </svg>
  )
}